import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import selectors from '@/scripts/animation/animation-selectors';

function getLinks(section, link) {
  return {
    links: Array.from(section.querySelectorAll(`${link}`)),
  };
}

function getAssets(link) {
  return {
    letters: Array.from(link.querySelectorAll(selectors.letter)),
    icon: link.querySelector(selectors.icon),
  };
}

export default {
  trigger: selectors.linkWithIcon,
  set() {
    const { links } = getLinks(this.section, selectors.linkWithIcon);
    links.forEach((link) => {
      const { letters, icon } = getAssets(link);
      return TweenMax.set([letters, icon], { autoAlpha: 0 });
    });
  },

  animate() {
    const { links } = getLinks(this.section, selectors.linkWithIcon);
    TweenMax.staggerTo(links, selectors.duration, {
      clearProps: 'all',
      onComplete() {
        const { letters, icon } = getAssets(this.target);
        const tl = new TimelineMax();
        return tl
          .staggerFromTo(
            letters, selectors.duration,
            { x: -20 },
            {
              autoAlpha: 1,
              x: 0,
              clearProps: 'all',
            }, selectors.delay.staggerLetters,
          )
          .fromTo(
            icon, selectors.duration,
            { x: -20 },
            { x: 0, autoAlpha: 1, clearProps: 'all' },
            selectors.delay.stage_3,
          );
      },
    }, selectors.delay.stagger);
  },
};



// WEBPACK FOOTER //
// ./scripts/animation/elements/link-with-icon.js